"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AdditionalProperties", {
  enumerable: true,
  get: function get() {
    return _AdditionalProperties.default;
  }
});
Object.defineProperty(exports, "AktionResponse", {
  enumerable: true,
  get: function get() {
    return _AktionResponse.default;
  }
});
Object.defineProperty(exports, "ApiClient", {
  enumerable: true,
  get: function get() {
    return _ApiClient.default;
  }
});
Object.defineProperty(exports, "ApplicationId", {
  enumerable: true,
  get: function get() {
    return _ApplicationId.default;
  }
});
Object.defineProperty(exports, "Auftrag", {
  enumerable: true,
  get: function get() {
    return _Auftrag.default;
  }
});
Object.defineProperty(exports, "AuftragResponse", {
  enumerable: true,
  get: function get() {
    return _AuftragResponse.default;
  }
});
Object.defineProperty(exports, "Auftragsart", {
  enumerable: true,
  get: function get() {
    return _Auftragsart.default;
  }
});
Object.defineProperty(exports, "Auftragsdetails", {
  enumerable: true,
  get: function get() {
    return _Auftragsdetails.default;
  }
});
Object.defineProperty(exports, "Auftragsliste", {
  enumerable: true,
  get: function get() {
    return _Auftragsliste.default;
  }
});
Object.defineProperty(exports, "Auftragsposition", {
  enumerable: true,
  get: function get() {
    return _Auftragsposition.default;
  }
});
Object.defineProperty(exports, "BackendPdfRequest", {
  enumerable: true,
  get: function get() {
    return _BackendPdfRequest.default;
  }
});
Object.defineProperty(exports, "Bearbeiter", {
  enumerable: true,
  get: function get() {
    return _Bearbeiter.default;
  }
});
Object.defineProperty(exports, "BestellDetails", {
  enumerable: true,
  get: function get() {
    return _BestellDetails.default;
  }
});
Object.defineProperty(exports, "Besteller", {
  enumerable: true,
  get: function get() {
    return _Besteller.default;
  }
});
Object.defineProperty(exports, "Boolean01", {
  enumerable: true,
  get: function get() {
    return _Boolean.default;
  }
});
Object.defineProperty(exports, "BooleanInt", {
  enumerable: true,
  get: function get() {
    return _BooleanInt.default;
  }
});
Object.defineProperty(exports, "BooleanJN", {
  enumerable: true,
  get: function get() {
    return _BooleanJN.default;
  }
});
Object.defineProperty(exports, "BooleanJaNein", {
  enumerable: true,
  get: function get() {
    return _BooleanJaNein.default;
  }
});
Object.defineProperty(exports, "DefaultApi", {
  enumerable: true,
  get: function get() {
    return _DefaultApi.default;
  }
});
Object.defineProperty(exports, "DeltaPos", {
  enumerable: true,
  get: function get() {
    return _DeltaPos.default;
  }
});
Object.defineProperty(exports, "EdelmetallItem", {
  enumerable: true,
  get: function get() {
    return _EdelmetallItem.default;
  }
});
Object.defineProperty(exports, "EdelmetallKatalog", {
  enumerable: true,
  get: function get() {
    return _EdelmetallKatalog.default;
  }
});
Object.defineProperty(exports, "EdelmetallKinds", {
  enumerable: true,
  get: function get() {
    return _EdelmetallKinds.default;
  }
});
Object.defineProperty(exports, "EdelmetallKondition", {
  enumerable: true,
  get: function get() {
    return _EdelmetallKondition.default;
  }
});
Object.defineProperty(exports, "EdelmetallKonditionen", {
  enumerable: true,
  get: function get() {
    return _EdelmetallKonditionen.default;
  }
});
Object.defineProperty(exports, "EdelmetallKonditionenStufen", {
  enumerable: true,
  get: function get() {
    return _EdelmetallKonditionenStufen.default;
  }
});
Object.defineProperty(exports, "EdelmetallListe", {
  enumerable: true,
  get: function get() {
    return _EdelmetallListe.default;
  }
});
Object.defineProperty(exports, "EdelmetallMakes", {
  enumerable: true,
  get: function get() {
    return _EdelmetallMakes.default;
  }
});
Object.defineProperty(exports, "EdelmetallPreis", {
  enumerable: true,
  get: function get() {
    return _EdelmetallPreis.default;
  }
});
Object.defineProperty(exports, "EdelmetallPreisResponse", {
  enumerable: true,
  get: function get() {
    return _EdelmetallPreisResponse.default;
  }
});
Object.defineProperty(exports, "EdelmetallProduktKonditionen", {
  enumerable: true,
  get: function get() {
    return _EdelmetallProduktKonditionen.default;
  }
});
Object.defineProperty(exports, "EdelmetallProduktStufen", {
  enumerable: true,
  get: function get() {
    return _EdelmetallProduktStufen.default;
  }
});
Object.defineProperty(exports, "EdelmetallStufenKondition", {
  enumerable: true,
  get: function get() {
    return _EdelmetallStufenKondition.default;
  }
});
Object.defineProperty(exports, "EdelmetallWarenkorb", {
  enumerable: true,
  get: function get() {
    return _EdelmetallWarenkorb.default;
  }
});
Object.defineProperty(exports, "EdelmetallWarenkorbResponse", {
  enumerable: true,
  get: function get() {
    return _EdelmetallWarenkorbResponse.default;
  }
});
Object.defineProperty(exports, "FilialeLieferadresse", {
  enumerable: true,
  get: function get() {
    return _FilialeLieferadresse.default;
  }
});
Object.defineProperty(exports, "FilialeLieferadresseChange", {
  enumerable: true,
  get: function get() {
    return _FilialeLieferadresseChange.default;
  }
});
Object.defineProperty(exports, "FilialenListe", {
  enumerable: true,
  get: function get() {
    return _FilialenListe.default;
  }
});
Object.defineProperty(exports, "Gebuehren", {
  enumerable: true,
  get: function get() {
    return _Gebuehren.default;
  }
});
Object.defineProperty(exports, "HeaderDaten", {
  enumerable: true,
  get: function get() {
    return _HeaderDaten.default;
  }
});
Object.defineProperty(exports, "HeaderRequest", {
  enumerable: true,
  get: function get() {
    return _HeaderRequest.default;
  }
});
Object.defineProperty(exports, "HeaderResponse", {
  enumerable: true,
  get: function get() {
    return _HeaderResponse.default;
  }
});
Object.defineProperty(exports, "KonditionChange", {
  enumerable: true,
  get: function get() {
    return _KonditionChange.default;
  }
});
Object.defineProperty(exports, "Konto", {
  enumerable: true,
  get: function get() {
    return _Konto.default;
  }
});
Object.defineProperty(exports, "Kunde", {
  enumerable: true,
  get: function get() {
    return _Kunde.default;
  }
});
Object.defineProperty(exports, "KundeLogin", {
  enumerable: true,
  get: function get() {
    return _KundeLogin.default;
  }
});
Object.defineProperty(exports, "KundeRequest", {
  enumerable: true,
  get: function get() {
    return _KundeRequest.default;
  }
});
Object.defineProperty(exports, "KundeResponse", {
  enumerable: true,
  get: function get() {
    return _KundeResponse.default;
  }
});
Object.defineProperty(exports, "KundenAdresse", {
  enumerable: true,
  get: function get() {
    return _KundenAdresse.default;
  }
});
Object.defineProperty(exports, "KundenListeResponse", {
  enumerable: true,
  get: function get() {
    return _KundenListeResponse.default;
  }
});
Object.defineProperty(exports, "Kursliste", {
  enumerable: true,
  get: function get() {
    return _Kursliste.default;
  }
});
Object.defineProperty(exports, "KurslisteItem", {
  enumerable: true,
  get: function get() {
    return _KurslisteItem.default;
  }
});
Object.defineProperty(exports, "Lieferadresse", {
  enumerable: true,
  get: function get() {
    return _Lieferadresse.default;
  }
});
Object.defineProperty(exports, "LoggerInfo", {
  enumerable: true,
  get: function get() {
    return _LoggerInfo.default;
  }
});
Object.defineProperty(exports, "Login", {
  enumerable: true,
  get: function get() {
    return _Login.default;
  }
});
Object.defineProperty(exports, "LogonClientNext", {
  enumerable: true,
  get: function get() {
    return _LogonClientNext.default;
  }
});
Object.defineProperty(exports, "MailversandTls", {
  enumerable: true,
  get: function get() {
    return _MailversandTls.default;
  }
});
Object.defineProperty(exports, "Mandant", {
  enumerable: true,
  get: function get() {
    return _Mandant.default;
  }
});
Object.defineProperty(exports, "MandantFile", {
  enumerable: true,
  get: function get() {
    return _MandantFile.default;
  }
});
Object.defineProperty(exports, "MandantRequest", {
  enumerable: true,
  get: function get() {
    return _MandantRequest.default;
  }
});
Object.defineProperty(exports, "MandantenFooter", {
  enumerable: true,
  get: function get() {
    return _MandantenFooter.default;
  }
});
Object.defineProperty(exports, "MandantenFooterZeile", {
  enumerable: true,
  get: function get() {
    return _MandantenFooterZeile.default;
  }
});
Object.defineProperty(exports, "Mandanteninfos", {
  enumerable: true,
  get: function get() {
    return _Mandanteninfos.default;
  }
});
Object.defineProperty(exports, "Mitarbeiter", {
  enumerable: true,
  get: function get() {
    return _Mitarbeiter.default;
  }
});
Object.defineProperty(exports, "MitarbeiterAnyOf", {
  enumerable: true,
  get: function get() {
    return _MitarbeiterAnyOf.default;
  }
});
Object.defineProperty(exports, "MitarbeiterKonditionenRequest", {
  enumerable: true,
  get: function get() {
    return _MitarbeiterKonditionenRequest.default;
  }
});
Object.defineProperty(exports, "Order", {
  enumerable: true,
  get: function get() {
    return _Order.default;
  }
});
Object.defineProperty(exports, "OrderPos", {
  enumerable: true,
  get: function get() {
    return _OrderPos.default;
  }
});
Object.defineProperty(exports, "OrderReport", {
  enumerable: true,
  get: function get() {
    return _OrderReport.default;
  }
});
Object.defineProperty(exports, "OrderReportMA", {
  enumerable: true,
  get: function get() {
    return _OrderReportMA.default;
  }
});
Object.defineProperty(exports, "OrderReportOnline", {
  enumerable: true,
  get: function get() {
    return _OrderReportOnline.default;
  }
});
Object.defineProperty(exports, "OrderStatus", {
  enumerable: true,
  get: function get() {
    return _OrderStatus.default;
  }
});
Object.defineProperty(exports, "Orders", {
  enumerable: true,
  get: function get() {
    return _Orders.default;
  }
});
Object.defineProperty(exports, "Personenart", {
  enumerable: true,
  get: function get() {
    return _Personenart.default;
  }
});
Object.defineProperty(exports, "RageRights", {
  enumerable: true,
  get: function get() {
    return _RageRights.default;
  }
});
Object.defineProperty(exports, "RequestAction", {
  enumerable: true,
  get: function get() {
    return _RequestAction.default;
  }
});
Object.defineProperty(exports, "RequestHeader", {
  enumerable: true,
  get: function get() {
    return _RequestHeader.default;
  }
});
Object.defineProperty(exports, "Session", {
  enumerable: true,
  get: function get() {
    return _Session.default;
  }
});
Object.defineProperty(exports, "Sorte", {
  enumerable: true,
  get: function get() {
    return _Sorte.default;
  }
});
Object.defineProperty(exports, "SorteKurs", {
  enumerable: true,
  get: function get() {
    return _SorteKurs.default;
  }
});
Object.defineProperty(exports, "SortenBestellung", {
  enumerable: true,
  get: function get() {
    return _SortenBestellung.default;
  }
});
Object.defineProperty(exports, "SortenKatalog", {
  enumerable: true,
  get: function get() {
    return _SortenKatalog.default;
  }
});
Object.defineProperty(exports, "SortenKonditionen", {
  enumerable: true,
  get: function get() {
    return _SortenKonditionen.default;
  }
});
Object.defineProperty(exports, "SortenKonditionenStufen", {
  enumerable: true,
  get: function get() {
    return _SortenKonditionenStufen.default;
  }
});
Object.defineProperty(exports, "SortenKontition", {
  enumerable: true,
  get: function get() {
    return _SortenKontition.default;
  }
});
Object.defineProperty(exports, "SortenKursResponse", {
  enumerable: true,
  get: function get() {
    return _SortenKursResponse.default;
  }
});
Object.defineProperty(exports, "SortenListe", {
  enumerable: true,
  get: function get() {
    return _SortenListe.default;
  }
});
Object.defineProperty(exports, "SortenProduktKonditionen", {
  enumerable: true,
  get: function get() {
    return _SortenProduktKonditionen.default;
  }
});
Object.defineProperty(exports, "SortenStufen", {
  enumerable: true,
  get: function get() {
    return _SortenStufen.default;
  }
});
Object.defineProperty(exports, "SortenStufenKondition", {
  enumerable: true,
  get: function get() {
    return _SortenStufenKondition.default;
  }
});
Object.defineProperty(exports, "SortenWarenkorb", {
  enumerable: true,
  get: function get() {
    return _SortenWarenkorb.default;
  }
});
Object.defineProperty(exports, "SortenWarenkorbResponse", {
  enumerable: true,
  get: function get() {
    return _SortenWarenkorbResponse.default;
  }
});
Object.defineProperty(exports, "Stammdaten", {
  enumerable: true,
  get: function get() {
    return _Stammdaten.default;
  }
});
Object.defineProperty(exports, "StammdatenResponse", {
  enumerable: true,
  get: function get() {
    return _StammdatenResponse.default;
  }
});
Object.defineProperty(exports, "StatusTyp", {
  enumerable: true,
  get: function get() {
    return _StatusTyp.default;
  }
});
Object.defineProperty(exports, "TanAuthRequest", {
  enumerable: true,
  get: function get() {
    return _TanAuthRequest.default;
  }
});
Object.defineProperty(exports, "WarenkorbPos", {
  enumerable: true,
  get: function get() {
    return _WarenkorbPos.default;
  }
});
Object.defineProperty(exports, "Warenkorbdetails", {
  enumerable: true,
  get: function get() {
    return _Warenkorbdetails.default;
  }
});
var _ApiClient = _interopRequireDefault(require("./ApiClient"));
var _AdditionalProperties = _interopRequireDefault(require("./model/AdditionalProperties"));
var _AktionResponse = _interopRequireDefault(require("./model/AktionResponse"));
var _ApplicationId = _interopRequireDefault(require("./model/ApplicationId"));
var _Auftrag = _interopRequireDefault(require("./model/Auftrag"));
var _AuftragResponse = _interopRequireDefault(require("./model/AuftragResponse"));
var _Auftragsart = _interopRequireDefault(require("./model/Auftragsart"));
var _Auftragsdetails = _interopRequireDefault(require("./model/Auftragsdetails"));
var _Auftragsliste = _interopRequireDefault(require("./model/Auftragsliste"));
var _Auftragsposition = _interopRequireDefault(require("./model/Auftragsposition"));
var _BackendPdfRequest = _interopRequireDefault(require("./model/BackendPdfRequest"));
var _Bearbeiter = _interopRequireDefault(require("./model/Bearbeiter"));
var _BestellDetails = _interopRequireDefault(require("./model/BestellDetails"));
var _Besteller = _interopRequireDefault(require("./model/Besteller"));
var _Boolean = _interopRequireDefault(require("./model/Boolean01"));
var _BooleanInt = _interopRequireDefault(require("./model/BooleanInt"));
var _BooleanJN = _interopRequireDefault(require("./model/BooleanJN"));
var _BooleanJaNein = _interopRequireDefault(require("./model/BooleanJaNein"));
var _DeltaPos = _interopRequireDefault(require("./model/DeltaPos"));
var _EdelmetallItem = _interopRequireDefault(require("./model/EdelmetallItem"));
var _EdelmetallKatalog = _interopRequireDefault(require("./model/EdelmetallKatalog"));
var _EdelmetallKinds = _interopRequireDefault(require("./model/EdelmetallKinds"));
var _EdelmetallKondition = _interopRequireDefault(require("./model/EdelmetallKondition"));
var _EdelmetallKonditionen = _interopRequireDefault(require("./model/EdelmetallKonditionen"));
var _EdelmetallKonditionenStufen = _interopRequireDefault(require("./model/EdelmetallKonditionenStufen"));
var _EdelmetallListe = _interopRequireDefault(require("./model/EdelmetallListe"));
var _EdelmetallMakes = _interopRequireDefault(require("./model/EdelmetallMakes"));
var _EdelmetallPreis = _interopRequireDefault(require("./model/EdelmetallPreis"));
var _EdelmetallPreisResponse = _interopRequireDefault(require("./model/EdelmetallPreisResponse"));
var _EdelmetallProduktKonditionen = _interopRequireDefault(require("./model/EdelmetallProduktKonditionen"));
var _EdelmetallProduktStufen = _interopRequireDefault(require("./model/EdelmetallProduktStufen"));
var _EdelmetallStufenKondition = _interopRequireDefault(require("./model/EdelmetallStufenKondition"));
var _EdelmetallWarenkorb = _interopRequireDefault(require("./model/EdelmetallWarenkorb"));
var _EdelmetallWarenkorbResponse = _interopRequireDefault(require("./model/EdelmetallWarenkorbResponse"));
var _FilialeLieferadresse = _interopRequireDefault(require("./model/FilialeLieferadresse"));
var _FilialeLieferadresseChange = _interopRequireDefault(require("./model/FilialeLieferadresseChange"));
var _FilialenListe = _interopRequireDefault(require("./model/FilialenListe"));
var _Gebuehren = _interopRequireDefault(require("./model/Gebuehren"));
var _HeaderDaten = _interopRequireDefault(require("./model/HeaderDaten"));
var _HeaderRequest = _interopRequireDefault(require("./model/HeaderRequest"));
var _HeaderResponse = _interopRequireDefault(require("./model/HeaderResponse"));
var _KonditionChange = _interopRequireDefault(require("./model/KonditionChange"));
var _Konto = _interopRequireDefault(require("./model/Konto"));
var _Kunde = _interopRequireDefault(require("./model/Kunde"));
var _KundeLogin = _interopRequireDefault(require("./model/KundeLogin"));
var _KundeRequest = _interopRequireDefault(require("./model/KundeRequest"));
var _KundeResponse = _interopRequireDefault(require("./model/KundeResponse"));
var _KundenAdresse = _interopRequireDefault(require("./model/KundenAdresse"));
var _KundenListeResponse = _interopRequireDefault(require("./model/KundenListeResponse"));
var _Kursliste = _interopRequireDefault(require("./model/Kursliste"));
var _KurslisteItem = _interopRequireDefault(require("./model/KurslisteItem"));
var _Lieferadresse = _interopRequireDefault(require("./model/Lieferadresse"));
var _LoggerInfo = _interopRequireDefault(require("./model/LoggerInfo"));
var _Login = _interopRequireDefault(require("./model/Login"));
var _LogonClientNext = _interopRequireDefault(require("./model/LogonClientNext"));
var _MailversandTls = _interopRequireDefault(require("./model/MailversandTls"));
var _Mandant = _interopRequireDefault(require("./model/Mandant"));
var _MandantFile = _interopRequireDefault(require("./model/MandantFile"));
var _MandantRequest = _interopRequireDefault(require("./model/MandantRequest"));
var _MandantenFooter = _interopRequireDefault(require("./model/MandantenFooter"));
var _MandantenFooterZeile = _interopRequireDefault(require("./model/MandantenFooterZeile"));
var _Mandanteninfos = _interopRequireDefault(require("./model/Mandanteninfos"));
var _Mitarbeiter = _interopRequireDefault(require("./model/Mitarbeiter"));
var _MitarbeiterAnyOf = _interopRequireDefault(require("./model/MitarbeiterAnyOf"));
var _MitarbeiterKonditionenRequest = _interopRequireDefault(require("./model/MitarbeiterKonditionenRequest"));
var _Order = _interopRequireDefault(require("./model/Order"));
var _OrderPos = _interopRequireDefault(require("./model/OrderPos"));
var _OrderReport = _interopRequireDefault(require("./model/OrderReport"));
var _OrderReportMA = _interopRequireDefault(require("./model/OrderReportMA"));
var _OrderReportOnline = _interopRequireDefault(require("./model/OrderReportOnline"));
var _OrderStatus = _interopRequireDefault(require("./model/OrderStatus"));
var _Orders = _interopRequireDefault(require("./model/Orders"));
var _Personenart = _interopRequireDefault(require("./model/Personenart"));
var _RageRights = _interopRequireDefault(require("./model/RageRights"));
var _RequestAction = _interopRequireDefault(require("./model/RequestAction"));
var _RequestHeader = _interopRequireDefault(require("./model/RequestHeader"));
var _Session = _interopRequireDefault(require("./model/Session"));
var _Sorte = _interopRequireDefault(require("./model/Sorte"));
var _SorteKurs = _interopRequireDefault(require("./model/SorteKurs"));
var _SortenBestellung = _interopRequireDefault(require("./model/SortenBestellung"));
var _SortenKatalog = _interopRequireDefault(require("./model/SortenKatalog"));
var _SortenKonditionen = _interopRequireDefault(require("./model/SortenKonditionen"));
var _SortenKonditionenStufen = _interopRequireDefault(require("./model/SortenKonditionenStufen"));
var _SortenKontition = _interopRequireDefault(require("./model/SortenKontition"));
var _SortenKursResponse = _interopRequireDefault(require("./model/SortenKursResponse"));
var _SortenListe = _interopRequireDefault(require("./model/SortenListe"));
var _SortenProduktKonditionen = _interopRequireDefault(require("./model/SortenProduktKonditionen"));
var _SortenStufen = _interopRequireDefault(require("./model/SortenStufen"));
var _SortenStufenKondition = _interopRequireDefault(require("./model/SortenStufenKondition"));
var _SortenWarenkorb = _interopRequireDefault(require("./model/SortenWarenkorb"));
var _SortenWarenkorbResponse = _interopRequireDefault(require("./model/SortenWarenkorbResponse"));
var _Stammdaten = _interopRequireDefault(require("./model/Stammdaten"));
var _StammdatenResponse = _interopRequireDefault(require("./model/StammdatenResponse"));
var _StatusTyp = _interopRequireDefault(require("./model/StatusTyp"));
var _TanAuthRequest = _interopRequireDefault(require("./model/TanAuthRequest"));
var _WarenkorbPos = _interopRequireDefault(require("./model/WarenkorbPos"));
var _Warenkorbdetails = _interopRequireDefault(require("./model/Warenkorbdetails"));
var _DefaultApi = _interopRequireDefault(require("./api/DefaultApi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }